import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { AvForm } from 'availity-mobx-reactstrap-validation';

import PaymentMethodFormState from 'js/stores/forms/PaymentMethodFormState';
import Button from 'js/components/common/Button';
import SubmitRow from 'js/components/core/Modal/SubmitRow';
import CreditCardForm from 'js/components/common/CreditCardForm';

import Container from './Container';
import CreditCardIcon from './CreditCardIcon';
import Title from './Title';
import ErrorDisplay from 'js/components/common/ErrorDisplay';

@inject('page')
@observer
export default class PaymentMethodForm extends Component {
  paymentMethodForm = PaymentMethodFormState.create();

  onSubmit = (event, values) => {
    if(!this.paymentMethodForm.creditCard.isFilledIn){
      return false;
    }

    values.address = this.paymentMethodForm.creditCard.address;
    this.props.page.saveCreditCard(values);
  };

  render() {
    const creditCard = this.paymentMethodForm.creditCard;
    const page = this.props.page;
    // creditCard.setBillingAddress(page.address);
    return (
      <Container>
        <AvForm onValidSubmit={this.onSubmit}>
          <CreditCardIcon />
          <Title>Payment method</Title>
          <CreditCardForm labels={false} creditCard={creditCard} />
          <SubmitRow>
            <Button type="submit" isLoading={page.isSavingCard} disabled={!creditCard.isFilledIn}>
              Save payment method
            </Button>
          </SubmitRow>

          <ErrorDisplay>{page.credit_card_error}</ErrorDisplay>
        </AvForm>
      </Container>
    );
  }
}
